import { ClinicalStatusEditForm } from 'application/clinical-status/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ClinicalStatusService } from 'application/clinical-status/services';
import { action } from 'mobx';

@applicationContext
class ClinicalStatusEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ClinicalStatusService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'clinical-status-edit',
            id: id,
            Form: ClinicalStatusEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ClinicalStatusEditForm,
        });
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Clinical Status already exists.' : err.data.message : `Error occurred while trying to update a Clinical Status.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Clinical Status already exists.' : err.data.message : `Error occurred while trying to update a Clinical Status.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('CLINICAL_STATUS.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('CLINICAL_STATUS.EDIT.SUCCESS_UPDATE', name);
    }
}

export default ClinicalStatusEditViewStore;
